import './index.css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRealBalanceObj, isSmartPhone, random } from '../../utilities/helper';
import { spinTheWheelGameUrl, spokesList } from '../../constants/spin_the_wheel';
import { setIsSpinTheWheel, setWalletBallance } from '../../actions/user-actions-types';
import { Dialog } from '@mui/material';

const SpinTheWheel = () => {
  const gameURL = spinTheWheelGameUrl;
  const spokes = JSON.stringify(spokesList);
  const { balanceInfo, isSpinTheWheelOpen = false } = useSelector((state: any) => state.user);
  const balance = getRealBalanceObj(balanceInfo);
  const dispatch = useDispatch();
  const sendMessageToIframe = (message: any) => {
    const iFameElem: any = document.getElementById('spinTheWheelIframe');
    iFameElem?.contentWindow.postMessage(message, '*');
  };

  useEffect(() => {
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  const onMessage = (e: any) => {
    const { command_type = '' } = e?.data || {};
    if (command_type === 'exit_game') {
      onPressClose();
    } else if (command_type === 'game_over') {
      onPressClose();
      updateBalance();
    } else if (command_type === 'game_start') {
      sendMessageToIframe_();
    }
  };
  const winnerSpokeIdProbability = random(1, 12);
  const sendMessageToIframe_ = () => {
    sendMessageToIframe({
      token: '',
      baseURL: '',
      wheelId: '',
      isConfigLoaded: true,
      spokes,
      winnerSpokeId: winnerSpokeIdProbability,
      type: 'sendConfigData'
    });
  };

  const updateBalance = () => {
    const winningSpoke = JSON.parse(spokes).find((ele: any) => ele._id == winnerSpokeIdProbability);
    const updateAmount = winningSpoke ? winningSpoke['rewardValue'] : 0;
    dispatch(
      setWalletBallance({
        bonusWallet: balance['bonusBalance'],
        gameWallet: balance['gameBalance'],
        primaryWallet: balance['primaryBalance'] + updateAmount / 100,
        pokerWallet: balance['pokerBalance'],
        cashbackWallet: balance['cashbackBalance']
      })
    );
  };

  const onPressClose = () => {
    dispatch(setIsSpinTheWheel(false));
  };

  return (
    <React.Fragment>
      <Dialog open={isSpinTheWheelOpen} style={{ bottom: '20px' }}>
        <div
          className={
            isSmartPhone
              ? 'spinTheWheel__modal__wrapper__mWeb '
              : 'spinTheWheel__modal__wrapper__web'
          }>
          <iframe
            id="spinTheWheelIframe"
            className="spinTheWheel__iframe"
            src={gameURL}
            allow="autoplay"
          />
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default SpinTheWheel;
